import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/pdfWorker";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// All encounters are for the UK NHS, so dates are displayed in Europe/London timezone.
dayjs.tz.setDefault("Europe/London");

// Preserve CLI-auth params across the /auth round-trip. Runs before React mounts so the
// AuthProvider's session-expired redirect to /auth can't drop our query string first.
if (window.location.pathname === "/cli/authorize" && window.location.search) {
  window.sessionStorage.setItem("cli_auth_return_to", window.location.pathname + window.location.search);
}

createRoot(document.getElementById("root")!).render(<App />);
